import React, { useState, useEffect } from "react";
import axios from "axios";
import ButtonOptionGroup from "../../component/ButtonOptions/ButtonOption";

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const ReportProfitLoss = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_REPORT = "api/erpppsu/report/LabaRugi";

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const [filterFirstDate, setFilterFirstDate] = useState(getTodayDate());
    const [filterLastDate, setFilterLastDate] = useState(getTodayDate());

    const fetchData = async (URL) => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(URL);
            return response.data;
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const loadData = () => {
        if (filterFirstDate && filterLastDate) {
            fetchData(
                `${BASE_URL}${PATH_REPORT}?first_date=${filterFirstDate}&last_date=${filterLastDate}`
            ).then((responseData) => {
                setData(responseData || []);
            });
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleFilter = () => {
        loadData();
    };

    const options = [
        { value: 'excel', label: 'Excel' },
        { value: 'pdf', label: 'PDF' },
        { value: 'csv', label: 'CSV' }
    ];

    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <div className="p-4">
            <div className='flex items-center justify-between'>
                <h1 className="text-lg font-bold mb-4">Laba Rugi</h1>

                <div className='flex items-center'>
                    <ButtonOptionGroup
                        label={"Ekspor"}
                        options={options}
                        onChange={async (value) => {
                            if (value == 'excel') {
                                const payload = {
                                    first_date: filterFirstDate,
                                    last_date: filterLastDate
                                };
                                const response = await axios.post(`${BASE_URL}${PATH_REPORT}/exportexcel`, payload, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                    }
                                });

                                setMessage(response.data);
                            } else if (value == 'pdf') {

                            } else if (value == 'csv') {

                            }
                        }}
                    />
                </div>
            </div>

            {error ? (
                <p className="bg-red-400 text-white p-2 rounded">Error: {error}</p>
            ) : null}

            {message ? (
                <p className="bg-blue-100 text-black p-2 rounded">{message}
                    <a target="_blank" href="/activity-erpppsu/import-export/exports"> Lihat daftar ekspor</a>
                </p>
            ) : null}

            <div className="container m-auto grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 my-3">
                <div>
                    <label htmlFor="first_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Awal
                    </label>
                    <input
                        id="first_date"
                        type="date"
                        className="p-2 w-full border rounded"
                        value={filterFirstDate}
                        onChange={(e) => setFilterFirstDate(e.target.value)}
                    />
                </div>
                <div>
                    <label htmlFor="last_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Akhir
                    </label>
                    <input
                        id="last_date"
                        type="date"
                        className="p-2 w-full border rounded"
                        value={filterLastDate}
                        onChange={(e) => setFilterLastDate(e.target.value)}
                    />
                </div>
                <div className="flex items-end">
                    <button
                        onClick={handleFilter}
                        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full"
                    >
                        Filter
                    </button>
                </div>
            </div>

            {loading ? (
                <div className="text-center">Loading...</div>
            ) : (
                data.map((section, sectionIndex) => {
                    const sectionData = Array.isArray(section.data) ? section.data : [section.data];

                    return (
                        <div key={sectionIndex} className="mb-8">
                            <h2 className="text-md font-semibold mb-3">{section.label}</h2>

                            {sectionData.map((subSection, subSectionIndex) => {
                                const total = subSection.total;
                                const isDataType = subSection.type === "data";
                                const isTotalType = subSection.type === "total";

                                const itemList = Array.isArray(subSection.data) ? subSection.data : [];

                                return (
                                    <div key={subSectionIndex} className="mb-5">
                                        {subSection.label && (
                                            <h3 className="text-sm font-medium mb-2">{subSection.label}</h3>
                                        )}

                                        {isDataType && itemList.length > 0 ? (
                                            <table className="min-w-full border-collapse border border-gray-300 text-sm">
                                                <thead>
                                                    <tr>
                                                        <th className="border px-2 py-1 text-left">Code</th>
                                                        <th className="border px-2 py-1 text-left">Name</th>
                                                        <th className="border px-2 py-1 text-right">Nominal</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {itemList.map((item, itemIndex) => (
                                                        <tr key={itemIndex}>
                                                            <td className="border px-2 py-1">{item.code}</td>
                                                            <td className="border px-2 py-1">{item.name}</td>
                                                            <td className="border px-2 py-1 text-right">
                                                                {Number(item.amount).toLocaleString("id-ID")}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td className="border px-2 py-1 font-semibold" colSpan={2}>
                                                            Total
                                                        </td>
                                                        <td className="border px-2 py-1 text-right font-semibold">
                                                            {Number(total).toLocaleString("id-ID")}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        ) : isDataType ? (
                                            <p className="text-gray-500">No data available.</p>
                                        ) : null}

                                        {isTotalType && (
                                            <table className="min-w-full border-collapse border border-gray-300 text-sm">
                                                <tfoot>
                                                    <tr>
                                                        <td className="border px-2 py-1 font-semibold" colSpan={2}>
                                                            Total
                                                        </td>
                                                        <td className="border px-2 py-1 text-right font-semibold">
                                                            {Number(total).toLocaleString("id-ID")}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })
            )}


        </div>
    );
};

export default ReportProfitLoss;